export const PATCH_APPLY_STATUS_META = Object.freeze({
  applied: {
    title: '文档已更新',
    description: '已更新右侧文档',
    tone: 'success',
    iconKind: 'success',
    color: '#16a34a',
  },
  cancelled: {
    title: '已取消修改',
    description: '已取消本次修改',
    tone: 'muted',
    iconKind: 'muted',
    color: '#64748b',
  },
  failed: {
    title: '文档未更新',
    description: '未命中可安全更新的位置，右侧未修改',
    tone: 'error',
    iconKind: 'error',
    color: '#dc2626',
    borderColor: '#fecaca',
  },
  needs_confirmation: {
    title: '需要确认更新',
    description: '需要确认后再更新',
    tone: 'warning',
    iconKind: 'warning',
    color: '#f59e0b',
    borderColor: '#fde68a',
  },
});

export const DEFAULT_PATCH_APPLY_STATUS_META = Object.freeze({
  title: '更新状态未完成',
  description: '更新状态未完成',
  tone: 'pending',
  iconKind: 'pending',
  color: '#2563eb',
});

export const PATCH_APPLY_REASON_LABELS = Object.freeze({
  confirmation_required: '需要你确认后再应用',
  target_text_not_found: '未命中可安全替换的原文',
  user_cancelled: '用户已取消',
});

export const PATCH_APPLY_TAB_LABELS = Object.freeze({
  analysis: '分析报告',
  requirement: '需求文档',
});
